<nav class="side-navbar" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <ul class="nav-menu navHeight list-unstyled" data-simplebar11>
        <div class="nav-tabs-wrapper">
            <li class="nav-item open-tab" *ngFor="let nav of navData" tooltip="{{(!nav.isHovered && !nav.isOpened ? nav.navTitle : '') | translate}}" placement="left" (click)="onNavItemClick(nav, navData, $event)">
                <div class="main-tab open-tab">
                    <a class="nav-link d-flex open-tab" [class.active]="isLinkActive(nav)">
                        <img class="svg-active open-tab" src="{{nav.svg}}">
                        <span class="nav-text open-tab" [@expanded]="layoutService.expandedMenu ? 'in' : 'out'">{{nav.navTitle | translate}}</span>
                    </a>
                    <img class="svg-expand open-tab" *ngIf="layoutService.expandedMenu && nav.tabs" src="{{ isExpandedTab(nav) ? 'assets/ph-bhp-layout/svg/menu/menu-opened.svg' : 'assets/ph-bhp-layout/svg/menu/menu-closed.svg' }}">
                </div>
                <div class="nav-tab" *ngIf="layoutService.expandedMenu && nav.tabs && nav.isOpened">
                    <a routerLink="{{ tab.navUrl }}" class="tab-link" *ngFor="let tab of nav.tabs">
                        <span class="nav-text tab-text">{{tab.name | translate}}</span>
                    </a>
                </div>
                <div class="nav-side-menu">
                    <div class="side-nav-tab nav-side-menu-tab" *ngIf="!layoutService.expandedMenu && nav.isHovered && nav.tabs">
                        <a routerLink="{{ tab.navUrl }}" class="nav-link tab-link" *ngFor="let tab of nav.tabs">
                            <p class="tab-text m-0">{{ tab.name | translate }}</p>
                        </a>
                    </div>
                </div>
            </li>
        </div>
        <div class="nav-tab-menu-wrapper">
            <li class="nav-item" tooltip="{{'LAYOUT_MODULE.CLOSE_MENU' | translate}}" placement="left">
                <a (click)="expandMenu()" class="nav-link d-flex">
                    <mat-icon class="expandIcon" [ngClass]="layoutService.expandedMenu ? 'isExpand' : ''" >chevron_right</mat-icon>
                    <span class="nav-text" [@expanded]="layoutService.expandedMenu ? 'in' : 'out'">{{'LAYOUT_MODULE.CLOSE_MENU' | translate}}</span>
                </a>
            </li>
        </div>
    </ul>
</nav>

<lib-ph-bhp-sidepanel class="feedback-sidepanel" [showsidebar]="feedbackMenu" (childData)="getEventAppMenu($event)">
    <div class="myapps-menu" data-simplebar>
        <h3 class="page-title">{{'GENERAL.FEEDBACK' | translate }}</h3>
        <p class="my-4">
            {{'GENERAL.CONTACT' | translate}}
        </p>
        <form #form="ngForm" (ngSubmit)="onSubmit(form.value)">
            <div class="form-group">
                <label>{{'GENERAL.CONTACT' | translate}}</label>
                <input type="text" #feedBackName="ngModel" required [(ngModel)]="model.name" name="name" class="form-control" placeholder="Enter name">
                <div class="md-errors-spacer" [hidden]="feedBackName.valid || feedBackName.untouched">
                    <div *ngIf="feedBackName.errors && feedBackName.errors.required">
                        {{'GENERAL.NAME_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>{{'CONFIGURE.E_MAIL' | translate}}</label>
                <input type="email" #feedBackEmail="ngModel" email="true" pattern="emailPattern" [(ngModel)]="model.email" name="email" class="form-control" placeholder="Enter e-mail" required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                <div class="md-errors-spacer" [hidden]="feedBackEmail.valid || feedBackEmail.untouched">
                    <div *ngIf="feedBackEmail.errors && feedBackEmail.errors.required">
                        {{ translationKeys.ProfileDetails.MailRequired | translate}}
                    </div>
                    <div *ngIf="feedBackEmail.errors && feedBackEmail.errors.pattern">
                        {{'AUTHORIZATION.EMAIL_INVALID' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>{{'CONFIGURE.MESSAGE' | translate}}</label>
                <textarea rows="4" #feedBackMgs="ngModel" required [(ngModel)]="model.mgs" name="mgs" class="form-control" maxlength="{{feedbackMgsMaxLength}}" placeholder="Write your message..."></textarea>
                <div class="form-control-descrition-msgs">
                    <span class="character-count-text">{{(model.mgs)?model.mgs.length : '0'}}
            /
            {{feedbackMgsMaxLength}} </span></div>
                <div class="md-errors-spacer" [hidden]="feedBackMgs.valid || feedBackMgs.untouched">
                    <div *ngIf="feedBackMgs.errors && feedBackMgs.errors.required">
                        {{'CONFIGURE.MESSAGE_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group mt-5">
                <button type="submit" class="btn btn-primary btn-block" [disabled]="(feedBackName.invalid || feedBackName.untouched || feedBackEmail.invalid || feedBackEmail.untouched || feedBackMgs.invalid || feedBackMgs.untouched)">Send</button>
            </div>
        </form>
    </div>
</lib-ph-bhp-sidepanel>